import {
  BACKWARDS_BOGO_SUBEXPERIENCES,
  EXPERIENCE_TAGS,
  FORWARDS_BOGO_SUBEXPERIENCES
} from './constants';

export const noop = () => { };

/**
 * @param {string} url
 * @returns {string}
 */
export const sanitizeImageUrl = (url = '') => url.replace(/<SIZE>/g, '400');

export const pipe = (...funcs) => (arg) => funcs.reduce((acc, cur) => cur(acc), arg);

/**
 * @template T
 * @param {T[]} list
 * @param {T} itemToMove
 * @returns {T[]}
 */
export const sortItemToTopOfList = (list, itemToMove) => (
  (list || [])
    .slice()
    .sort((first, second) => {
      if (first === itemToMove) return -1;
      if (second === itemToMove) return 1;
      return 0;
    })
    // We will no longer need to slice at 16 once we have moved to searchModel
    .slice(0, 16) // no more than 16 items including the anchor
);

/**
 * @param {Object} obj
 * @param {string} obj.subExperienceTag
 * @returns {boolean}
 */
const isForwardsBogo = ({ subExperienceTag }) => {
  return FORWARDS_BOGO_SUBEXPERIENCES.some((subExperience) => subExperience === subExperienceTag);
};

/**
 * @param {Object} obj
 * @param {string} obj.subExperienceTag
 * @returns {boolean}
 */
export const isBackwardsBogo = ({ subExperienceTag }) => {
  return BACKWARDS_BOGO_SUBEXPERIENCES.some((subExperience) => subExperience === subExperienceTag);
};

/**
 * @param {Object} obj
 * @param {Object[]} obj.eligibilityCriteria
 * @returns {any[]}
 */
const getQualifyingItemList = ({ eligibilityCriteria }) => {
  const qualifyingObject = eligibilityCriteria.find((eligibilityCriterion) => {
    return eligibilityCriterion.itemGroup === 'SRC-1';
  });
  return qualifyingObject.omsSkus;
};

/**
 * @param {Object} obj
 * @param {any[]} obj.eligibilityCriteria
 * @returns {any[]}
 */
const getRewardItemList = ({ eligibilityCriteria }) => {
  const rewardObject = eligibilityCriteria.find((eligibilityCriterion) => {
    return eligibilityCriterion.itemGroup === 'TGT-1';
  });
  return rewardObject.omsSkus;
};

/**
 * @param {Object} obj
 * @param {Object} obj.anchorItem
 * @returns {any[]}
 */
export const getItemList = ({ anchorItem }) => {
  const { eligibilityCriteria, subExperienceTag, experienceTag } = anchorItem.pricing.conditionalPromotions[0];
  if (experienceTag === EXPERIENCE_TAGS.BOGO && !isBackwardsBogo({ subExperienceTag })) {
    return getRewardItemList({ eligibilityCriteria });
  }
  return getQualifyingItemList({ eligibilityCriteria });
};

export const getProductImage = (productData) => productData.media?.image?.url || '';

/**
 *
 * @param {Object} obj
 * @param {boolean} obj.prop
 * @param {boolean} obj.config
 * @param {boolean} [obj.defaultValue]
 * @returns {boolean}
 */
export const getIsFeatureEnabled = ({ prop, config, defaultValue = false }) => {
  if (prop === false || config === false) return false;
  if (prop === true || config === true) return true;
  return defaultValue;
};

/**
 * @param {Object} obj
 * @param {string | null} obj.experienceTag
 * @param {string | null} obj.subExperienceTag
 * @param {boolean} obj.backwardsBogoEnabled Backwards BOGO feature switch
 * @param {boolean} obj.bogoEnabled Overall BOGO feature switch
 * @param {boolean} obj.bmsmEnabled BMSM feature switch
 * @param {boolean} obj.msbEnabled MSB feature switch
 * @returns {boolean} Whether the promotion is enabled
 */
export const isPromotionEnabled = ({
  experienceTag,
  subExperienceTag,
  backwardsBogoEnabled,
  bogoEnabled,
  bmsmEnabled,
  msbEnabled
}) => {
  switch (experienceTag) {
  case EXPERIENCE_TAGS.BOGO: {
    if (isForwardsBogo({ subExperienceTag })) {
      return bogoEnabled;
    }

    if (isBackwardsBogo({ subExperienceTag })) {
      return bogoEnabled && backwardsBogoEnabled;
    }

    return false;
  }
  case EXPERIENCE_TAGS.BMSM:
    return bmsmEnabled;
  case EXPERIENCE_TAGS.MSB:
    return msbEnabled;
  default:
    return false;
  }
};
